import { ListProps, List as MuiList } from '@mui/material';

type Props = Pick<ListProps, 'children' | 'className' | 'sx'>;

const List = ({ children, className, sx }: Props) => {
  return (
    <MuiList className={className} sx={sx}>
      {children}
    </MuiList>
  );
};

export default List;
